/** Shared action button corner radius (px) — use explicit px to avoid :root 80% rem shrink. */
export const BUTTON_BORDER_RADIUS = "5px";
export const buttonRadiusClassName = "rounded-[5px]";
